import PropTypes from 'prop-types';

export const StringOrNumberType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
]);

export const NoteType = PropTypes.shape({
  id: PropTypes.number,
  roleId: PropTypes.number,
  memberId: PropTypes.number,
  locationId: PropTypes.number,
  objId: PropTypes.number,
  objType: PropTypes.string,
  subObjId: PropTypes.number,
  subObjType: PropTypes.string,
  note: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  member: PropTypes.shape({
    id: PropTypes.number,
    firstname: PropTypes.string,
    lastname: PropTypes.string
  })
});

export const FileType = PropTypes.shape({
  id: PropTypes.number,
  locationId: PropTypes.number,
  fileName: PropTypes.string,
  objId: PropTypes.number,
  objType: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.number,
  createdAt: PropTypes.string
});

export const OptionType = PropTypes.shape({
  value: StringOrNumberType.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({})
});

export const SelectOptionsType = PropTypes.arrayOf(OptionType);

export const VisitConfigType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  configType: PropTypes.string.isRequired,
  configOption: PropTypes.string.isRequired,
  canDelete: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired
});

export const VisitConfigsType = PropTypes.arrayOf(VisitConfigType);
